/* eslint-disable react/no-children-prop */
import ModeIcon from "@mui/icons-material/Mode";
import CachedIcon from "@mui/icons-material/Cached";
import React, { useState, createRef } from "react";
import { Stack, Button, Typography, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { PromptCard } from "../../molecules";
import { setRegister } from "../../../redux/slices/registerSlice";
import { useFormik } from "formik";
import { ReactSketchCanvas } from "react-sketch-canvas";
import {
  api,
  apiUrls,
  saveAllData,
  uploadPhoto,
} from "../../../services/apiService";
import { setAlert } from "../../../redux/slices/alertSlice";

export const SignedFormSection = ({ onClickNext }) => {
  const dispatch = useDispatch();
  const canvas = createRef(null);
  const regData = useSelector((state) => state.register);
  const [isLoading, setIsLoading] = useState(false);
  const [checkStrokes, setCheckStrokes] = useState(false);
  const [error, setError] = useState(false);

  const uploadAll = async (data) => {
    console.log(
      "apiEndpoint",
      apiUrls.saveAll + regData.idNumber + "/" + regData.recordID
    );
    console.log("data", data);
    const response = await api.post(
      apiUrls.saveAll +
        (regData.idNumber ? regData.idNumber : "1812031231231233") +
        "/" +
        (regData.recordID
          ? regData.recordID
          : "717d1bf59c5f8d140d19f5985546d0e5"),
      data,
      { headers: { "Content-Type": "text/plain" } }
    );
    try {
      if (response?.data?.success) {
        onClickNext();
      }
    } catch (error) {
      dispatch(setAlert({ message: "Error uploading data", isOpen: true }));
    }
  };

  const formProps = useFormik({
    initialValues: regData,
    onSubmit: async () => {
      setIsLoading(true);
      if (checkStrokes) {
        try {
          const data = await canvas.current.exportImage("png");
          const resSign = await uploadPhoto(
            data,
            "uploadSignature",
            regData.idNumber,
            apiUrls.uploadSignature
          );
          const signPath = { customerSign: resSign.data.file_name };
          const uploadAllData = { ...regData, ...signPath };
          console.log("uploadAllData", uploadAllData);

          const save = saveAllData(uploadAllData);
          console.log("save", save);

          dispatch(setRegister(signPath));

          const uploadAllDataTest = {
            typeFPRE: 2,
            Ind_Email: "ridhoadhadigani+pemrek@gmail.com",
            Ind_NomorHP: "082123054525",
            kode_sales: "",
            Ind_NPWP: "",
            NamaNasabah: "Ridho TEST 1",
            row: 2,
            Ind_TempatLahir: "test",
            Ind_TglLahir: "1997-07-07",
            Ind_JenisKelamin: "2",
            Ind_Id_alamat1: "dasd",
            Ind_Id_Kota: "asdas",
            IDCardRT: "071",
            IDCardRW: "997",
            Ind_Id_kodePos: "012",
            ktp_path: "5f3e410e7f0e3b7f2f6c5f89fe335aa3.jpg",
            Ind_Perkawinan: "2",
            NamaIbuKandung: "test",
            Ind_SumberUtamaDana: "1",
            Ind_SumberUtamaDanaLainnya: "",
            Ind_Pekerjaan: "46",
            Ind_Bekerjapadaperusahaan: "Henan Asset",
            Ind_BidangUsaha: "asd",
            Ind_Jabatan: "asd",
            Ind_Kantor_alamat1: "asda",
            Ind_Kantor_kota: "sd",
            Ind_Kantor_kodepos: "34174",
            Ind_Kantor_telepon: "082123054525",
            Ind_TujuanInvestasi1: "1",
            Ind_TujuanInvestasi1_Lainnya: "",
            Ind_PenghasilanTahun: "3",
            Ind_InstruksiAS: "1",
            Ind_AlamatKorespondensi: "1",
            Ind_tinggal_alamat1: "dasd",
            Ind_tinggal_kota: "asdas",
            DomicileRT: "071",
            DomicileRW: "997",
            Ind_tinggal_kodepos: "012",
            Ind_WargaNegara: "1",
            Ind_Kantor_negara: "Indonesia",
            Ind_Agama: "1",
            Ind_Pendidikan: "3",
            bank_rdn: "B114",
            Ind_NamaPemilikRekening: "Ridho TEST",
            Ind_NomorRekening: "123",
            rdn_bca: "0",
            no_acc_bca: "",
            Ind_BankID: "B009",
            Ind_NamaBank: "BCA",
            rdn_bca_npwp: "1",
            rdn_bca_agreement: "1",
            Ind_BekerjaPadaEfek: "2",
            rekening_efek_lain: "2",
            rekening_sid: "",
            Ind_BeneficialOwner: "",
            Ind_BeneficialOwner_Nama: "",
            swafoto_path: "5f3e410e7f0e3b7f2f6c5f89fe335aa3.jpg",
            signature_path: "dd388ca788840c60717b1e90ff0bcf52.jpg",
          };

          uploadAll(save);
        } catch (error) {
          dispatch(setAlert({ message: "Error uploading data", isOpen: true }));
        } finally {
          setIsLoading(false);
        }
      }
    },
  });

  return (
    <Stack
      spacing="32px"
      justifyContent="space-between"
      style={{ height: "100%" }}
    >
      <Stack spacing="32px">
        <PromptCard
          icon={<ModeIcon style={{ width: "40px", height: "40px" }} />}
          title="Spesimen Tanda Tangan"
          subtitle="Silahkan tanda tangani di area kotak yang sudah kami berikan"
        />
        <Typography
          style={{ fontWeight: 700, fontSize: "14px", textAlign: "center" }}
        >
          Pastikan tanda tangan kamu semirip mungkin dengan yang ada di KTP kamu
          supaya tidak ditolak.
        </Typography>
        <Stack gap="3px">
          <ReactSketchCanvas
            ref={canvas}
            strokeWidth={2}
            width="40%"
            id="customerSign"
            name="customerSign"
            height="100%"
            strokeColor="black"
            canvasColor="white"
            style={{
              margin: "auto",
              cursor: "crosshair",
              width: "100%",
              height: "50vh",
              border: `1px dashed ${error ? "#ff1744" : "#515151"}`,
              borderRadius: "8px",
              overflow: "hidden",
            }}
            onStroke={() => {
              setCheckStrokes(true);
              setError(false);
            }}
          />
          {error && (
            <Typography
              style={{
                fontWeight: 400,
                fontSize: "0.75rem",
                lineHeight: 1.66,
                color: "#ff1744",
              }}
            >
              Tanda tangan kosong
            </Typography>
          )}
        </Stack>
        <Button
          type="submit"
          variant="outlined"
          disableElevation
          style={{
            textTransform: "none",
            width: "fit-content",
            gap: "10px",
            fontSize: "16px",
          }}
          onClick={() => {
            canvas.current.clearCanvas();
            setError(true);
          }}
        >
          <CachedIcon style={{ fontSize: "22px" }} />
          Ulangi
        </Button>
      </Stack>

      <Button
        type="submit"
        variant="contained"
        disableElevation
        style={{ textTransform: "none" }}
        disabled={isLoading}
        onClick={() => {
          checkStrokes ? formProps?.handleSubmit() : setError(true);
        }}
      >
        {isLoading ? <CircularProgress size={24} /> : "Berikutnya"}
      </Button>
    </Stack>
  );
};

SignedFormSection.propTypes = {
  onClickNext: PropTypes.func,
};
